import qiniuUpload from './qiniuUpload.js'
import auth from './auth.js'
//eslint-disable-next-line
export default {
    ...qiniuUpload,
    ...auth
}